import React, { FunctionComponent, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field, FormikErrors, FormikValues } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  proceedToNextFormStep,
  goBack,
} from "../../../actions/diversityFormActions";
import RadioButton from "../../shared/publicForms/RadioButton";
import TextField from "../../shared/publicForms/TextField";
import {
  StepWrapper,
  Title,
  RadioButtonGroupWrapper,
  RadioButtonGroup,
  BackButton,
  ButtonsWrapper,
  Button,
  DisabledButton,
} from "../styles/diversity-form-styles";

export interface IPronounsProps {
  values: {
    pronouns?: undefined | string;
  };
  errors: FormikErrors<FormikValues>;
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate: boolean
  ) => void;
  proceedToNextFormStepAction: typeof proceedToNextFormStep;
  goBackAction: typeof goBack;
}

export const Pronouns: FunctionComponent<IPronounsProps> = ({
  values,
  errors,
  proceedToNextFormStepAction,
  goBackAction,
  setFieldValue,
}) => {
  const radioButtonOptions = [
    null,
    "He/Him",
    "She/Her",
    "They/Them",
    "Other",
    "Prefer not to say",
  ];

  return (
    <StepWrapper data-test-id="pronouns-step" formStep>
      <Title data-test-id="title">Which pronouns do you use?</Title>
      <RadioButtonGroupWrapper
        role="group"
        aria-labelledby="pronouns-radio-group"
      >
        <RadioButtonGroup width={185}>
          {radioButtonOptions
            .filter((option) => option)
            .map((option) =>
              option === "Other" ? (
                <Fragment key={option}>
                  <Field
                    key={option}
                    name="pronouns"
                    type="radio"
                    aria-label={option}
                    label={option}
                    value={option}
                    onChange={() => setFieldValue("pronouns", "", true)}
                    checked={!radioButtonOptions.includes(values.pronouns)}
                    as={RadioButton}
                  />
                  {!radioButtonOptions.includes(values.pronouns) && (
                    <Field
                      name="pronouns"
                      type="text"
                      aria-label={values.pronouns}
                      placeholder="Please specify"
                      as={TextField}
                    />
                  )}
                </Fragment>
              ) : (
                <Field
                  key={option}
                  name="pronouns"
                  type="radio"
                  aria-label={option}
                  label={option}
                  value={option}
                  as={RadioButton}
                />
              )
            )}
        </RadioButtonGroup>
      </RadioButtonGroupWrapper>
      <ButtonsWrapper>
        <BackButton type="button" onClick={goBackAction}>
          <FontAwesomeIcon icon={faChevronLeft} />
          back
        </BackButton>
        {values.pronouns && !errors.pronouns ? (
          <Button
            type="button"
            onClick={proceedToNextFormStepAction}
            data-test-id="next-button"
          >
            Next
          </Button>
        ) : (
          <DisabledButton type="button">Next</DisabledButton>
        )}
      </ButtonsWrapper>
    </StepWrapper>
  );
};

Pronouns.propTypes = {
  values: PropTypes.shape({
    pronouns: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    pronouns: PropTypes.string,
  }).isRequired,
  proceedToNextFormStepAction: PropTypes.func.isRequired,
  goBackAction: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
};

export default connect(null, {
  proceedToNextFormStepAction: proceedToNextFormStep,
  goBackAction: goBack,
})(Pronouns);
